import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface ContractorBadge {
  title?: string | null;
  logoUrl?: string | null;
}

// 'logo': fixed-size logo only, for cramped tables; nothing is shown when there is no logo.
export type ContractorBadgeMode = 'short' | 'full' | 'logo';

// 'UAB „Darbius"' -> 'Darbius', 'Workis OÜ' -> 'Workis'
export function shortContractorName(title: string): string {
  const short = title
    .replace(/^(UAB|SIA|AS)\s+/i, '')
    .replace(/\s+(OÜ|OU|AS)$/i, '')
    .replace(/["„“”]/g, '')
    .trim();
  return short || title;
}

@Component({
  selector: 'app-contractor-badge',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './contractor-badge.component.html',
  styleUrls: ['./contractor-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractorBadgeComponent {
  private $contractor: ContractorBadge | null;

  @Input() mode: ContractorBadgeMode = 'short';

  logoFailed = false;

  @Input() set contractor(value: ContractorBadge | null) {
    this.$contractor = value;
    this.logoFailed = false;
  }
  get contractor() {
    return this.$contractor;
  }

  get name(): string {
    const title = this.contractor?.title || '';
    return this.mode === 'full' ? title : shortContractorName(title);
  }
}
